import { type Instance, type SnapshotOut, types } from 'mobx-state-tree';

export const UserModel = types
  .model('User')
  .props({
    accessCode: types.maybe(types.string),
    email: types.string,
    gender: types.maybe(types.string),
    goal_weight_units: types.maybe(types.string),
    goal_weight_value: types.maybe(types.number),
    goal: types.maybe(types.number),
    height_units: types.maybe(types.string),
    height_value: types.maybe(types.number),
    id: types.maybe(types.union(types.number, types.string)),
    isPasswordSet: types.boolean,
    isSubscriptionActive: types.boolean,
    serverId: types.union(types.number, types.string),
    token: types.maybe(types.string),
    useMetricSystem: types.maybe(types.boolean),
    user_data: types.maybe(types.frozen<Record<string, any>>()),
    weight_units: types.maybe(types.string),
    weight_value: types.maybe(types.number),
  })
  .actions((self) => ({
    setEmail: (value: string) => {
      self.email = value;
    },
    setPasswordSet: () => {
      self.isPasswordSet = true;
    },
  }));

type UserType = Instance<typeof UserModel>;
export interface User extends UserType {}
type UserSnapshotType = SnapshotOut<typeof UserModel>;
export interface UserSnapshot extends UserSnapshotType {}
